import React from 'react';
import { Dialog } from '@headlessui/react';
import { useTranslation } from 'react-i18next';

export default function TopUpSuccess({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { t } = useTranslation();
  return (
    <Dialog as="div" className="relative z-10" open={open} onClose={onClose}>
      <div className="fixed inset-0 bg-black/50 dark:bg-black/70" aria-hidden="true" />
      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center">
          <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white dark:bg-slate-800 p-6 text-left align-middle shadow-xl transition-all">
            <Dialog.Title className="font-medium leading-6 text-gray-900 dark:text-white">
              {t('common:paymentSuccess.subTitle')}
            </Dialog.Title>
            <button
              onClick={onClose}
              type="button"
              className="btn bg-orange dark:bg-teal-500 text-white rounded-full px-6 py-2 mt-4 hover:bg-orange/90 dark:hover:bg-teal-600 transition-colors"
            >
              {t('common:generalSuccess.buttonText')}
            </button>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
}
